// 侧边栏菜单配置
// 侧边栏菜单配置
export default [
  {
    path: '/certificates',
    name: 'certificates',
    label: '证书列表',
    icon: 'el-icon-document'
  },
  {
    path: '/import-history',
    name: 'importHistory',
    label: '导入历史记录',
    icon: 'el-icon-time'
  }
]